import { render } from "./AppLayoutDefault.vue?vue&type=template&id=32bfb512"
const script = {}

import exportComponent from "/usr/src/app/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__